// extracted by mini-css-extract-plugin
module.exports = {"main":"_2Z8xRje9IqlbA0AkbPQ4Jv","crumb":"_3PzhxuDhQhPUsTyxFZ0ccf","divisor":"_2bedCauPOt7lSn5BD4RSyy"};